import { parseDate } from '@/utils/date'
import DatePicker from 'react-datepicker'
import { createPortal } from 'react-dom'

import 'react-datepicker/dist/react-datepicker.css'
import './ContentDatepicker.css'

export const ContentDatepicker = ({
    value,
    placeholder,
    onChange,
}) => {
    
    return (
        <div className="content-editable__datepicker">
            <DatePicker 
                selected={value ? parseDate(value, null, false) : null} 
                onChange={value => onChange(value)} 
                dateFormat="MM/dd/yyyy"
                placeholderText={placeholder}
                showMonthDropdown
                showYearDropdown
                // eslint-disable-next-line no-restricted-globals
                popperContainer={({ children }) => createPortal(children, document.body)}
                dropdownMode="select"/>
        </div>
    )
}
